import { Link } from "@tanstack/react-router";

import { GoLink, Section, displayTitle, fogClass } from "@/features/platform/components/landing-ui";
import { cn } from "@/lib/utils";
import { m } from "@/paraglide/messages.js";

/** The last band: the claim once more on the wash, and the one thing to do. */
export const PlatformClosing = () => (
  <Section>
    <div
      className={cn(
        "relative isolate overflow-hidden rounded-[32px] border border-border bg-background px-5 py-16 text-center md:py-24",
        fogClass,
      )}
    >
      <h2 className={cn(displayTitle, "mx-auto max-w-[760px]")}>{m.platform_closing_title()}</h2>
      <p className="mx-auto mt-5 max-w-[460px] text-lg leading-[1.55] text-muted-foreground">
        {m.platform_closing_body()}
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-2.5">
        <GoLink to="/signup" tone="accent">
          {m.platform_closing_cta()}
        </GoLink>
        <Link
          to="/login"
          className="inline-flex h-10 items-center rounded-full border border-border bg-background px-[18px] text-sm font-medium transition-colors hover:bg-muted"
        >
          {m.landing_nav_sign_in()}
        </Link>
      </div>
    </div>
  </Section>
);
